export const replacePropName = (
	sourceCode: string,
	{
		oldProp,
		newProp,
		componentName,
	}: {
		oldProp: string;
		newProp: string;
		componentName: string;
	},
) => {
	const regex = new RegExp(
		`(<${componentName}[^>]*?)\\b${oldProp}(=\\s*(?:"[^"]*"|\\{[^}]*\\}))(.*?)`,
		'gs',
	);
	return sourceCode.replace(regex, (_, p1: string, value: string, p3: string) => {
		return `${p1}${newProp}${value}${p3}`;
	});
};
